{
  "decrease": "Reduser {fieldLabel}",
  "increase": "Øk {fieldLabel}",
  "numberField": "Tallfelt"
}
